// Shared constants for the Our Work view

const DEFAULT_ITEMS_PER_PAGE = 12;
const MOBILE_ITEMS_PER_PAGE = 6;
const COLLABORATORS_ITEMS_PER_PAGE = 30;

const FILTER_CATEGORIES = [
  { id: 'sector', label: 'Sectors' },
  { id: 'service', label: 'Services' },
  { id: 'project', label: 'Projects' },
  { id: 'competence', label: 'Competences' },
  { id: 'partner', label: 'Collaborators' },
];

const SECTION_TO_FILTER = {
  sectors: 'sector',
  services: 'service',
  projects: 'project',
  competences: 'competence',
  collaborators: 'partner',
};

const PROJECT_SUB_FILTERS = [
  { id: 'all', label: 'View all' },
  { id: 'coordination', label: 'Coordination' },
  { id: 'finished', label: 'Finished' },
  { id: 'ongoing', label: 'Ongoing' },
];

const FILTER_ALL = 'All';
const FILTER_OTHERS = 'Others';
const PROJECT_SECTORS_SUBREQUEST = 'ourWorkProjectSectors';

const DEFAULT_GRID_BREAKPOINTS = [
  { minWidth: 0, columns: 1 },
  { minWidth: 768, columns: 2 },
  { minWidth: 1024, columns: 3 },
  { minWidth: 1440, columns: 4 },
];

const COLLABORATORS_GRID_BREAKPOINTS = [
  { minWidth: 0, columns: 3, gap: '0.5rem' },
  { minWidth: 1024, columns: 5, gap: '1rem' },
  { minWidth: 1280, columns: 6, gap: '1rem' },
];

const EMPTY_ITEMS = [];

// Metadata fields we need from the catalog (no fullobjects required)
const DEFAULT_METADATA_FIELDS = [
  'is_coordinated',
  'is_operational',
  'start_date',
  'end_date',
  'Subject',
  'image_field',
  'image_scales',
  'short_description',
  'portal_type',
  'related_sectors_titles',
];

const COLLABORATORS_METADATA_FIELDS = ['image_field', 'image_scales', 'url'];

export {
  DEFAULT_ITEMS_PER_PAGE,
  MOBILE_ITEMS_PER_PAGE,
  COLLABORATORS_ITEMS_PER_PAGE,
  FILTER_CATEGORIES,
  SECTION_TO_FILTER,
  PROJECT_SUB_FILTERS,
  FILTER_ALL,
  FILTER_OTHERS,
  PROJECT_SECTORS_SUBREQUEST,
  DEFAULT_GRID_BREAKPOINTS,
  COLLABORATORS_GRID_BREAKPOINTS,
  EMPTY_ITEMS,
  DEFAULT_METADATA_FIELDS,
  COLLABORATORS_METADATA_FIELDS,
};
